import { render, staticRenderFns } from "./AdSenseFeed.vue?vue&type=template&id=3c35bb06&scoped=true&"
import script from "./AdSenseFeed.vue?vue&type=script&lang=js&"
export * from "./AdSenseFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35bb06",
  null
  
)

export default component.exports